/**
 * Founder-only Memory view. Complimentary is the existing inner-circle flag.
 * Localhost so the view can be opened while developing.
 */
export function canViewBrainMemory({ complimentary = false, hostname = '' } = {}) {
  if (complimentary) return true;
  return hostname === 'localhost' || hostname === '127.0.0.1';
}
